import { isStripeApplePayEnabled } from 'utils/stripe';
import { stripeApplePayPaymentAttempt } from '../../actions/stripeApplePay';
import useStripeExpressWallet from './useStripeExpressWallet';
import useStripeApplePaySdk from './useStripeApplePaySdk';

/**
 * useStripeApplePay hook.
 * Thin wrapper over the shared `useStripeExpressWallet` orchestrator bound to Apple Pay:
 * tenant gating via `isStripeApplePayEnabled`, the `apple_pay` payment type, the Apple Pay
 * payment attempt, and the Apple Pay SDK hook.
 *
 * @param {object} props - onPaymentButtonClick.
 * @param {Function} props.onPaymentButtonClick - Callback when the Apple Pay button is clicked;
 *   receives `{ resolve, reject }` to gate the wallet sheet on checkout validations.
 * @param {Function} [props.beforeWalletPayment] - Optional current Quick Purchase check before dispatch.
 * @returns {object} Apple Pay ECE state and container ref.
 */
function useStripeApplePay({ onPaymentButtonClick, beforeWalletPayment }) {
  return useStripeExpressWallet({
    onPaymentButtonClick,
    beforeWalletPayment,
    enabled: isStripeApplePayEnabled(),
    paymentType: 'apple_pay',
    paymentAttempt: stripeApplePayPaymentAttempt,
    useWalletSdk: useStripeApplePaySdk,
  });
}

export default useStripeApplePay;
